import { BASE_PATH as M, BaseAPI as O, operationServerMap as R } from "../base.js";
import { DUMMY_BASE_URL as b, assertParamExists as i, createRequestFunction as C, serializeDataIfNeeded as u, setSearchParams as g, toPathString as v } from "../common.js";
import p from "axios";
var V = function(a) {
  return {
    merchantMemberChargeRecordCreate: async (c, t = {}) => {
      i("merchantMemberChargeRecordCreate", "merchantMemberChargeRecordVO", c);
      const h = new URL("/merchant_member_charge_record/create", b);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", g(h, n);
      let d = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...t.headers
      }, e.data = u(c, e, a), {
        url: v(h),
        options: e
      };
    },
    merchantMemberChargeRecordGetMerchantMemberChargeRecord: async (c, t = {}) => {
      i("merchantMemberChargeRecordGetMerchantMemberChargeRecord", "query", c);
      const h = new URL("/merchant_member_charge_record/list", b);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...t
      }, o = {}, n = {};
      if (c !== void 0) for (const [m, s] of Object.entries(c)) n[m] = s;
      g(h, n);
      let d = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...t.headers
      }, {
        url: v(h),
        options: e
      };
    },
    merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord: async (c, t = {}) => {
      i("merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord", "chargeRecordId", c);
      const h = new URL("/merchant_member_charge_record/single", b);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...t
      }, o = {}, n = {};
      c !== void 0 && (n.chargeRecordId = c), g(h, n);
      let d = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...t.headers
      }, {
        url: v(h),
        options: e
      };
    },
    merchantMemberChargeRecordQueryById: async (c, t = {}) => {
      i("merchantMemberChargeRecordQueryById", "merchantMemberChargeRecord", c);
      const h = "/merchant_member_charge_record/{merchantMemberChargeRecord}".replace("{merchantMemberChargeRecord}", encodeURIComponent(String(c))), r = new URL(h, b);
      let e;
      a && (e = a.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...t
      }, n = {};
      g(r, {});
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...n,
        ...d,
        ...t.headers
      }, {
        url: v(r),
        options: o
      };
    },
    merchantMemberChargeRecordRevoke: async (c, t = {}) => {
      i("merchantMemberChargeRecordRevoke", "memberChargeRevokeDTO", c);
      const h = new URL("/merchant_member_charge_record/revoke", b);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, o = {}, n = {};
      o["Content-Type"] = "application/json", g(h, n);
      let d = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...d,
        ...t.headers
      }, e.data = u(c, e, a), {
        url: v(h),
        options: e
      };
    }
  };
}, l = function(a) {
  const c = V(a);
  return {
    async merchantMemberChargeRecordCreate(t, h) {
      var r, e;
      const o = await c.merchantMemberChargeRecordCreate(t, h), n = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, d = (e = R["MerchantMemberChargeRecordApi.merchantMemberChargeRecordCreate"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (m, s) => C(o, p, M, a)(m, d || s);
    },
    async merchantMemberChargeRecordGetMerchantMemberChargeRecord(t, h) {
      var r, e;
      const o = await c.merchantMemberChargeRecordGetMerchantMemberChargeRecord(t, h), n = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, d = (e = R["MerchantMemberChargeRecordApi.merchantMemberChargeRecordGetMerchantMemberChargeRecord"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (m, s) => C(o, p, M, a)(m, d || s);
    },
    async merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord(t, h) {
      var r, e;
      const o = await c.merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord(t, h), n = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, d = (e = R["MerchantMemberChargeRecordApi.merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (m, s) => C(o, p, M, a)(m, d || s);
    },
    async merchantMemberChargeRecordQueryById(t, h) {
      var r, e;
      const o = await c.merchantMemberChargeRecordQueryById(t, h), n = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, d = (e = R["MerchantMemberChargeRecordApi.merchantMemberChargeRecordQueryById"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (m, s) => C(o, p, M, a)(m, d || s);
    },
    async merchantMemberChargeRecordRevoke(t, h) {
      var r, e;
      const o = await c.merchantMemberChargeRecordRevoke(t, h), n = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, d = (e = R["MerchantMemberChargeRecordApi.merchantMemberChargeRecordRevoke"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (m, s) => C(o, p, M, a)(m, d || s);
    }
  };
}, A = function(a, c, t) {
  const h = l(a);
  return {
    merchantMemberChargeRecordCreate(r, e) {
      return h.merchantMemberChargeRecordCreate(r.merchantMemberChargeRecordVO, e).then((o) => o(t, c));
    },
    merchantMemberChargeRecordGetMerchantMemberChargeRecord(r, e) {
      return h.merchantMemberChargeRecordGetMerchantMemberChargeRecord(r.query, e).then((o) => o(t, c));
    },
    merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord(r, e) {
      return h.merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord(r.chargeRecordId, e).then((o) => o(t, c));
    },
    merchantMemberChargeRecordQueryById(r, e) {
      return h.merchantMemberChargeRecordQueryById(r.merchantMemberChargeRecord, e).then((o) => o(t, c));
    },
    merchantMemberChargeRecordRevoke(r, e) {
      return h.merchantMemberChargeRecordRevoke(r.memberChargeRevokeDTO, e).then((o) => o(t, c));
    }
  };
}, P = class extends O {
  merchantMemberChargeRecordCreate(a, c) {
    return l(this.configuration).merchantMemberChargeRecordCreate(a.merchantMemberChargeRecordVO, c).then((t) => t(this.axios, this.basePath));
  }
  merchantMemberChargeRecordGetMerchantMemberChargeRecord(a, c) {
    return l(this.configuration).merchantMemberChargeRecordGetMerchantMemberChargeRecord(a.query, c).then((t) => t(this.axios, this.basePath));
  }
  merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord(a, c) {
    return l(this.configuration).merchantMemberChargeRecordGetSingleMerchantMemberChargeRecord(a.chargeRecordId, c).then((t) => t(this.axios, this.basePath));
  }
  merchantMemberChargeRecordQueryById(a, c) {
    return l(this.configuration).merchantMemberChargeRecordQueryById(a.merchantMemberChargeRecord, c).then((t) => t(this.axios, this.basePath));
  }
  merchantMemberChargeRecordRevoke(a, c) {
    return l(this.configuration).merchantMemberChargeRecordRevoke(a.memberChargeRevokeDTO, c).then((t) => t(this.axios, this.basePath));
  }
};
export {
  P as MerchantMemberChargeRecordApi,
  V as MerchantMemberChargeRecordApiAxiosParamCreator,
  A as MerchantMemberChargeRecordApiFactory,
  l as MerchantMemberChargeRecordApiFp
};

//# sourceMappingURL=merchant-member-charge-record-api.js.map